import angular from 'angular';

angular.module('app.ctrls')
    .controller('crmConnectionsController', ['$rootScope', '$scope', '$state', 'ClusterService', 'DateRangeService', 'UserService', '$ioAlert', 'CrmConnectionsService', function($rs, $scope, $state, ClusterService, DateRangeService, UserService, $ioAlert, CrmConnectionsService) {
        $scope.services = [];
        $scope.loadFail = false;

        init();

        function getCrmServices() {
            CrmConnectionsService.getServices().then(function() {
                $scope.services = CrmConnectionsService.services;
                $scope.clientsLoader = false;
            }, function(error) {
                $scope.clientsLoader = false;
                $scope.loadFail = true;
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        }

        function init() {

            //Cluster Selector currently does nothing on this page, disabling
            ClusterService.initCluster($rs.userRole, 'disabled', $rs.userRole.cluster_id);
            DateRangeService.init();
            getCrmServices();
        }

    }]);
